var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center"}},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("Страница не найдена. Перейти на сайт "),_c('a',{attrs:{"href":"https://www.medicina.ru/kontakty/"}},[_vm._v("Медицины")])])])
}]

export { render, staticRenderFns }